export default __webpack_public_path__ + "static/medium-complexity-6c8ecd51d6f45eb3fac3402f986fadcccd79b35a261ecc6f4f61dcb773d6fad5.png";